module.exports = __webpack_public_path__ + "img/app-mobile.ea2a4933.jpg";